import React, { useEffect, useState } from 'react';
import { Box } from '@material-ui/core';
import FolderIcon from '@material-ui/icons/Folder';
import LabelManageResult from './components/label_manage_result/index';
import { useDispatch, useSelector } from 'dva';
import LabelManageStyled from './labelManageStyled';
import AntdTree from '@/components/AntdTree/AntdTree';

export default () => {
  const dispatch = useDispatch();
  const [isEdit, setIsEdit] = useState(false);
  const [treeValue, setTreeValue] = useState();
  const [initExpandedKeys, setInitExpandedKeys] = useState();

  // 取type不是7的第一个传入人数
  const { labelDirectoryList } = useSelector((state) => state.labelManage);

  useEffect(() => {
    dispatch({
      type: 'labelManage/getQueryTagTreeCL',
      payload: {
        values: {},
      },
    });
  }, [dispatch]);
  useEffect(() => {
    if (labelDirectoryList && labelDirectoryList.length > 0 && !treeValue) {
      setTreeValue(labelDirectoryList[0].id);
    }
  }, [labelDirectoryList, treeValue]);

  const selectValueSet = (value) => {
    // const arr = getParentId(labelDirectoryList, value[0]).reverse();
    setTreeValue(value[0]);
    setIsEdit(false);
  };
  return (
    <LabelManageStyled>
      <div
        id="label_id_mount_parent"
        data-log={JSON.stringify({
          oid: 'page_user_profile_tag_directory_list',
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
          },
          events: ['_pv', '_pd'],
        })}
        className="search-condition-left"
      >
        <Box
          sx={{
            color: '#212121',
            fontSize: '18px',
            height: '24px',
            lineHeight: '24px',
            fontWeight: '600',
            marginBottom: '23px',
            marginLeft: '8px',
          }}
        >
          目录详情
        </Box>
        <AntdTree
          treeData={labelDirectoryList}
          fieldNames={{ title: 'name', key: 'id' }}
          selectValueSet={selectValueSet}
          value={treeValue}
          isNoSearch={true}
          initExpandedKeys={initExpandedKeys}
          minWidth="100%"
          icon={
            <FolderIcon
              sx={{ width: 15, color: '#000000', marginRight: '7px' }}
            ></FolderIcon>
          }
        ></AntdTree>
      </div>
      <LabelManageResult
        tagId={treeValue}
        setTreeValue={setTreeValue}
        labelDirectoryList={labelDirectoryList}
        isEdit={isEdit}
        setIsEdit={setIsEdit}
        setInitExpandedKeys={setInitExpandedKeys}
      ></LabelManageResult>
    </LabelManageStyled>
  );
};
